'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('InspirationsModalCtrl', InspirationsModalCtrl);

  InspirationsModalCtrl.$inject = ['$scope', '$state', '$stateParams', '$filter', 'inspirationSvc', 'mediaQuerySvc', 'preloader', 'allInspirations', 'close'];

  /* @ngInject */
  function InspirationsModalCtrl($scope, $state, $stateParams, $filter, inspirationSvc, mediaQuerySvc, preloader, allInspirations, close) {
    var vm = this;
    var REQUESTING_PAGE = false;
    var _pageSize = mediaQuerySvc.getGridPageSize();
    // Modal Service doesn't use the vm.$onInit lifecycle hook. Need to call activate() directily.
    // This PR will add support for $onInit: https://github.com/dwmkerr/angular-modal-service/pull/190
    _init();

    // When this modal is closed from the view, go to the state which originally opened this modal.
    // That is:  .detail (current $state) -> .modal (this state) -> grandparent $state
    vm.closeModal = function () {
      // Pass all the inspirations through modal.close() back to the parent controller.
      close(allInspirations, 300);
      $scope.$on('$destroy', function () {
        return $state.go('^.^');
      });
    };

    // If we start to route someplace new, close this modal, and route AFTER the modal has been destroyed.
    // This prevents flickering in the UI and keeps it consistent with vm.closeModal.
    $scope.$on('$stateChangeStart', function (e, toState, toParams) {
      if (!$state.is(toState.name)) {
        e.preventDefault();
        close(false, 300);
        $scope.$on('$destroy', function () {
          return $state.go(toState.name, toParams);
        });
      }
    });

    // Reinitialize the vm when the state changes.
    $scope.$on('$stateChangeSuccess', _init);

    ////////////////

    // Sets the next/prev links in the view, and requests a new page of inspirations if necessary.
    function _init() {
      _setNextPrevInsp($state.params.url, allInspirations);
      if (_isNearingEndOfPage($stateParams.url) && !$stateParams.disableInspirationBrowsing) {
        fetchNewPage();
      }
    }

    function fetchNewPage() {
      if (REQUESTING_PAGE) {
        return;
      }
      REQUESTING_PAGE = true;
      return inspirationSvc.getNextPage($stateParams.type || 'new', _pageSize, true).then(function (newInspirations) {
        allInspirations = _.uniqBy(allInspirations.concat(newInspirations), 'url');
        REQUESTING_PAGE = false;
        _setNextPrevInsp($state.params.url, allInspirations);
      });
    }

    function _setNextPrevInsp(thisInspirationUrl, collection) {
      // If this inspiration is a part of a collection, we show the next/prev buttons.
      // Otherwise, don't show them.
      if (_.isArray(collection)) {
        var idx = _.findIndex(collection, function (i) {
          return i.url === thisInspirationUrl;
        });
        vm.prev = collection[idx - 1];
        vm.next = collection[idx + 1];

        if (vm.next) {
          preloader.preloadImageUrlString($filter('msImgixSrc')(vm.next.image, 'largeLandscape'));
        }
        if (vm.prev) {
          preloader.preloadImageUrlString($filter('msImgixSrc')(vm.prev.image, 'largeLandscape'));
        }
      }
    }

    // Returns `true` if the inspiration with thisUrl is one of the last quarter of inspirations in the collection.
    // The last quarter is an arbitrary number.
    function _isNearingEndOfPage(thisUrl) {
      var rowSize = Math.floor(_pageSize / 4) || 6;
      return _.get(allInspirations, 'length') - _.findIndex(allInspirations, ['url', thisUrl]) <= rowSize;
    }
  }
})();